module.exports = __webpack_public_path__ + "img/561342623.14e52615.jpg";